import UserStorageMixin from '@/plugins/mixin-userstorage';
import * as behaviorLogApi from '@/api/behavior-log';
import { getMe } from '@/api/mypage';

export default {
  mixins: [UserStorageMixin],
  computed: {
    isLoggedIn() {
      return this.$store.state.user;
    },
  },
  methods: {
    async behaviorMixin__getMyKiId() {
      if (this.isLoggedIn) {
        return getMe();
      }
      return this.getUserStorage();
    },
    async retrieveSiteAccessLogs(page) {
      const userId = await this.behaviorMixin__getMyKiId();
      const logs = await behaviorLogApi.getAccessLogs(userId, page);
      this.$store.commit('setViewHistory', logs);
      return logs;
    },
    async setSiteAccessLogs(view) {
      const userId = await this.behaviorMixin__getMyKiId();
      await behaviorLogApi.postAccessLogs(userId, view);
      await behaviorLogApi.postHistoricalAccessLog(userId, {
        id: view.id,
      });
      return this.retrieveSiteAccessLogs();
    },
    async deleteSiteAccessLog(logId) {
      const userId = await this.behaviorMixin__getMyKiId();
      await behaviorLogApi.deleteAccessLog(userId, logId);
      return this.retrieveSiteAccessLogs();
    },
    async deleteAllSiteAccessLogs() {
      const userId = await this.behaviorMixin__getMyKiId();
      await behaviorLogApi.deleteAllAccessLogs(userId);
      return this.retrieveSiteAccessLogs();
    },
    async retrieveSiteQueryLogs(page) {
      const userId = await this.behaviorMixin__getMyKiId();
      const logs = await behaviorLogApi.getQueryLogs(userId, page);
      this.$store.commit('setSearchHistory', logs);
      return logs;
    },
    async setSiteQueryLogs(log, areaLog) {
      const userId = await this.behaviorMixin__getMyKiId();
      await behaviorLogApi.postQueryLogs(userId, log);
      await behaviorLogApi.postQueryLogsHistorical(userId, areaLog);
      return this.retrieveSiteQueryLogs();
    },
    async deleteSiteQueryLog(logId) {
      const userId = await this.behaviorMixin__getMyKiId();
      await behaviorLogApi.deleteQueryLog(userId, logId);
      return this.retrieveSiteQueryLogs();
    },
    async deleteAllSiteQueryLogs() {
      const userId = await this.behaviorMixin__getMyKiId();
      await behaviorLogApi.deleteAllQueryLogs(userId);
      return this.retrieveSiteQueryLogs();
    },
    async retrieveWishList() {
      const userId = await this.behaviorMixin__getMyKiId();
      const wishList = await behaviorLogApi.retrieveWishList(userId);
      this.$store.commit('setFavorite', wishList);
      return wishList;
    },
    async retrieveFullWishList() {
      const userId = await this.behaviorMixin__getMyKiId();
      const wishListFirstPage = await behaviorLogApi.retrieveWishList(userId, 1);

      const pageArray = [];
      for (let i = 1; i <= wishListFirstPage.lastPage; i += 1) {
        pageArray.push(i);
      }

      const promises = pageArray.map(i => new Promise(async (resolve) => {
        const data = await behaviorLogApi.retrieveWishList(userId, i);
        resolve(data);
      }));

      const results = await Promise.all(promises);
      return results.reduce((a, b) => [...a, ...b.data], []);
    },
    async addWishList(property) {
      const userId = await this.behaviorMixin__getMyKiId();
      await behaviorLogApi.postWishList(userId, property);
      return this.retrieveWishList();
    },
    async updateWishListPrices(property, id) {
      const userId = await this.behaviorMixin__getMyKiId();
      await behaviorLogApi.putWishList(userId, id, property);
    },
    async deleteWishList(propertyId) {
      const userId = await this.behaviorMixin__getMyKiId();
      await behaviorLogApi.deleteWishList(userId, propertyId);
      return this.retrieveWishList();
    },
    async getLastSearchedArea() {
      const userId = await this.behaviorMixin__getMyKiId();
      return behaviorLogApi.getLastSearchedArea(userId);
    },
  },
};
